import { Chain } from '@ankr.com/chains-list';

import { AccountPermission } from 'modules/permissions/constants';
import { EndpointsContainer } from 'modules/chains/components/EndpointsContainer';
import { ChainSelectorsProvider } from 'modules/chains/components/ChainSelectorsProvider';
import { GuardAccountPermission } from 'modules/account/components/GuardAccountPermission';
import { PremiumContent } from 'modules/common/components/GetStartedSection/components/PremiumContent';

import { useMultichainEndpointsStyles } from './useMultichainEndpointsStyles';

interface MultichainEndpointsProps {
  chain: Chain;
}

export const MultichainEndpoints = ({ chain }: MultichainEndpointsProps) => {
  const { classes } = useMultichainEndpointsStyles();

  return (
    <div className={classes.root}>
      <ChainSelectorsProvider chain={chain}>
        <EndpointsContainer />
      </ChainSelectorsProvider>
      <GuardAccountPermission permission={AccountPermission.UpgradePlan}>
        <PremiumContent />
      </GuardAccountPermission>
    </div>
  );
};
